<p-toast />
<div class="full-wrapper flex-center min-h-screen">
  <p-card class="login-card flex-column gap-4">
    <ng-template pTemplate="header">
      <div class="flex-center pt-4 full-width gap-5">
        @if(institution()?.logoDirectory) {
          <img 
            [src]="institution()?.logoDirectory" 
            class="logo" 
            [alt]="institution()?.name" 
            style="width: 50px; height: auto;" 
          />
        }
        <h1 class="text-2xl font-bold ml-2">{{ institution()?.shortName }}</h1>
      </div>
    </ng-template>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-column gap-5">
      <div class="full-width flex-column">
        <p-floatlabel>
          <input pInputText 
          id="nickname" 
          formControlName="nickname" 
          class="full-width input-border-standard p-2" />
          <label for="nickname">Nome de Usuário ou Telefone</label>
        </p-floatlabel>
        <small class="error-msg">
          @if (form.get('nickname')?.invalid && form.get('nickname')?.touched) {
            Nome de usuário ou telefone é obrigatório
          }
          &nbsp;</small>
      </div>

      <div class="full-width flex-column">
        <p-floatlabel>
          <p-password 
          formControlName="password" 
          [toggleMask]="true" 
          [feedback]="false" 
          inputId="password" 
          autocomplete="off" 
          class="full-width input-border-standard" />
          <label for="password">Senha</label>
        </p-floatlabel>

        <small class="error-msg">
        @if (form.get('password')?.invalid && form.get('password')?.touched) {
          Senha é obrigatória
        }
        &nbsp;</small>
      </div>

      <div class="flex-center full-width">
        <button
          type="submit"
          class="flex-center full-width btn btn-1"
          [disabled]="!form.valid || loading">
          <i class="pi pi-sign-in"></i>
          Entrar
        </button>
      </div>
    </form>
  </p-card>
</div>